import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-crm-cookie-policy',
  templateUrl: './crm-cookie-policy.component.html',
  styleUrls: ['./crm-cookie-policy.component.scss']
})
export class CrmCookiePolicyComponent    {

}